import { getRecoil, setRecoil } from "recoil-nexus";
import { ApplicationListData, appPermission, authenticate, marketCode, activeFilterName } from '../../Recoil-State';
import { orderBy, sortBy, uniqBy } from "lodash";
import { BaseURL } from "../../environment";

export class HTTPService {
    constructor(http, apiurl) {
        this.HTTP = http;
        this.baseURL = apiurl
    }
    checkAppAccess(app) {
        let isValid  = false;
        let isAccess = getRecoil(appPermission);
        if ( isAccess ) {
            let { access } = app || {};
            if ( access) {
                access = access.filter(e=> e);
                if ( access && access.length> 0 ) {
                    isValid = access.some(x=> isAccess.includes(x)) || false;
                }
            }
        }

        return isValid;

                      
    }
    mapUserAccess(data, accessPermission) {

        if ( accessPermission ) {
            data = data.map(e=> {
                let { access } = e || {};
                let obj ={...e};
                if ( access) {
                    access = access.filter(e=> e);
                    if ( access && access.length> 0 ) {
                        obj.isAccess = access.some(x=> accessPermission.includes(x)) || false;
                    }
                }
                return e;
            })

        }
        return data;
    }
    uniqByRegion(data){
        let list = uniqBy(data, 'regionName');
        let filters = list.map(e=> ({label: e?.regionName, value: e?.regionShortName}));
        filters = orderBy(filters, ['label'], ['asc']);
        let _activeFilterName = getRecoil(activeFilterName);
        let active = filters && _activeFilterName ? _activeFilterName : filters.length > 0 ? filters[0]?.value : 'GBL';

            return ({
                filterData: [
                { icon: 'pi pi-heart w-1rem', label: 'My Favourite', value: 'favourite' },
                ...filters
            ],
            active
        });
    }

    async getAPPList(query) {
        try {
            const response = await this.HTTP.GET(`${this.baseURL}/getApplications`);
            let result = (response && response?.responseListObject) || [];
            return result;

        }
        catch (e) {
            console.log(e.toString());
        }
    }

    filterAPPList(apps, name) {
        let data = apps.filter(app => {
            if (app?.regionShortName?.trim() === name?.trim()) {
                return true;
            }
            if (name === 'favourite' && app?.favourite) {
                return true;
            }
        })
        return data // orderBy(data, ['favourite'], ['desc']);
    }

    filterByText(apps, text, appFilter) {
        text = text && text?.trim();
        if (appFilter) {
            apps = this.filterAPPList(apps, appFilter);
        }
        let data = apps.filter(app => {
            let match1 = app?.application?.match(new RegExp(text, 'gi'));
            let match2 = app?.applicationName?.match(new RegExp(text, 'gi'));
            let match3 = app?.appName?.match(new RegExp(text, 'gi'));
            return (match1 || match2 || match3) ? true : false;
        })
        return  data //orderBy(data, ['isFav'], ['desc']);
    }


    async postFeedbackListApi(data, id) {
        try {

            let internalFeedbackDate = new Date();
            const internalFeedbackUserCountryCode = getRecoil(marketCode);
            const { fullName, firstName, userName } = getRecoil(authenticate) || {};
            let req = {
                id: id,
                internalFeedback: [
                    {
                        ...data,
                        internalFeedbackDate,
                        internalFeedbackUserCountryCode,
                        internalFeedbackUserName: (fullName || firstName),
                        internalFeedbackUsrPrid: userName,
                        internalFeedbackUserClusterCode: internalFeedbackUserCountryCode,
                    }
                ]
            };
            const response = this.HTTP.POST(`${this.baseURL}/content/asset/rating`, req);
            return response
        }
        catch (e) {
            console.log(e.toString());
        }
    }

    updateArrayFav(data, appInfo) {
        let app = {};
        Object.assign(app, appInfo);
        let { applicationId, favourite } = app || {};

        let list = [...data];
        list = list.map(e => {
            if (e?.applicationId === applicationId) {
                return ({ ...e, favourite: !favourite })
            } else {
                return e;
            }
        });
        return list;
    }

    updateFavObj(data, appInfo) {
        let app = {};
        Object.assign(app, appInfo);
        let index = data.findIndex(e => e?.appName === app?.appName);
        data.splice(index, 1, { ...app, favourite: !app?.favourite });
        return data;
    }

    async addToFav(data) {
        try {
            let apps = getRecoil(ApplicationListData);
            let list = await this.updateFavObj(apps, data);
            data = { ...data, favourite: !data?.favourite };
            const response = await this.HTTP.POST(`generic/user-application`, [data]);
            await setRecoil(ApplicationListData, [...list]);
            return response
        }
        catch (e) {
            console.log(e.toString());
        }

    }
    
    async redirectToLogout(baseURL) {        
        try {            
            const response = await this.HTTP.GET(`${baseURL}/logout`);
            return response;
        }
        catch (e) {
            console.log(e.toString());
        }
    }

    async logout() {        
        try {
            this.redirectToLogout(BaseURL).then(res => {
                const logoutURL = `https://auth.azap.astrazeneca.com/logout?response_type=code&client_id=${res?.id}&scope=openid profile&redirect_uri=${BaseURL}`;
                window.top.location.href = logoutURL;
            });
        }
        catch (e) {
            console.error(e.toString());
        }
    }

}
